// MC Next-flavored text overrides for the shared Simulator step components
// (used by both the standalone MC Next Interactive Simulator and MC Next Case
// Studies). MC Next runs on Data Cloud, so most step copy (DMOs, Identity
// Resolution, Unified Individual) is identical to Data Cloud's default — only
// the Agentforce Personalization insight step and the Distributed/BU-Scoped
// Activation step need MC Next-specific wording.
export const MC_NEXT_SIMULATOR_TERMS = {
  insightStepTitle: "Step 6b — Build an Agentforce Personalization",
  activateTitle: "Step 7 — Distributed & BU-Scoped Activation",
  activateDescription: "Review your full pipeline, then activate the Segment through the correct Business-Unit-scoped, consent-checked destination for this business scenario.",
};
